const privaGlobal = {
    darkmode: false,
    alert: {
        show: false,
        body: "",
        title: "",
        bodyStyle: {
            textAlign: "center",
        },
        footerStyle: {
            justifyContent: "center",
        },
        onClose: () => ({}),
    },
    settings: {},
    creditCardForm: {
        show: false,
        onClose: () => ({}),
        closeOnly: false,
        prefilled: false,
        currency: "",
        formLoading: true,
        mode: "add",
        nextAction: "",
    },
    tipForm: {
        show: false,
        postId: null,
        nextAction: "",
    },
};

export default privaGlobal;
